import React from 'react'
import { View } from 'styles/reactnative'

import { Button, Select, message } from 'antd'
import { useToken } from 'app/hooks'
import API from 'utils/api'
import ClassificationSelect from '../../../components/AdminUserModal/ClassificationSelect'
import { column_order_page } from '../../../components/AdminUserModal/UserInfoTabs/column_order_page'
import TableAPI from '../../../components/TableAPI'
import { useExchangeList } from '../../../hooks/trade/exchangeList'

const WaitOrder = ({ title, type }: any) => {
	const [user_id, setUser_id] = React.useState('')
	const [status, setStatus] = React.useState<any>('*')
	const [limit, setLimit] = React.useState<any>('*')
	const [ep_id, setEp_id] = React.useState<any>('*')
	const [level, setLevel] = React.useState<any>(1)
	const { data: EPS } = useExchangeList()
	const today = new Date().toISOString().slice(0, 10)
	const activeEPS = EPS?.filter((item: any) => item.openstatus !== 4 && item.startdate <= today && item.enddate > today)

	const { data: token } = useToken()

	return (
		<View style={{ width: '100%' }}>
			<View
				style={{
					flexDirection: 'row',
					backgroundColor: 'white',
					width: '100%',
					padding: 10,
					marginTop: 10,
					borderTopLeftRadius: 10,
					borderTopRightRadius: 10,
				}}>
				<View style={{ width: 200 }}>
					<ClassificationSelect
						defaultValue={level}
						setSelectLevel={setLevel}
						disabled={false}
					/>
				</View>

				<Select
					value={ep_id}
					onChange={e => {
						setEp_id(e)
					}}
					filterOption={true}
					options={[
						{ value: '*', label: '전체종목' },
						...activeEPS?.map((item: any) => {
							return {
								value: item.id,
								label: (item.groupname || item.name) + ' (' + item?.pairs + ')',
							}
						}),
					]}
					style={{ marginRight: 10, minWidth: 200 }}
				/>
				<Select
					value={limit}
					onChange={e => {
						setLimit(e)
					}}
					filterOption={true}
					options={[
						{ value: '*', label: '지정가시장가' },
						{ value: 'L', label: '지정가' },
						{ value: 'M', label: '시장가' },
					]}
					style={{ marginRight: 10 }}
				/>

				<Button
					type="primary"
					onClick={() => {
						if (
							window.confirm(
								'시장가 주문을 일괄취소하시겠습니까?'
							) === false
						)
							return

						API.post('/admin/trade/cancelall', token + '', {}).then(
							res => {
								message.success('주문이 취소되었습니다.')
							}
						)
					}}>
					시장가 일괄취소
				</Button>
			</View>

			<TableAPI
				title={title}
				columns={column_order_page}
				usermodal={true}
				height={'default'}
				loadingshow={false}
				groupsearch={true}
				width={1350}
				autorefresh={5000}
				apikey={
					'/admin/history/orders?ep_id=' +
					ep_id +
					'&user_id=' +
					(user_id || 0) +
					(level === '*' ? '' : '&level=' + level) +
					(limit === '*' ? '' : '&ordertype=' + limit) +
					'&status=1&='
				}
			/>
		</View>
	)
}

export default React.memo(WaitOrder)
